import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { Icon } from 'antd';

export default class CheckoutComponent extends React.Component {

	static propTypes = {
		challengeUrl: PropTypes.string.isRequired,
		initialStep: PropTypes.string.isRequired,
		count: PropTypes.number.isRequired,
		push: PropTypes.func.isRequired,
		isSwag: PropTypes.bool.isRequired
	};

	_onClick = () => {
		//Don't take them anywhere if they're already in the join race wizard for any race
		//if (!window.location.pathname.startsWith('/races/') && !window.location.pathname.startsWith('/store/')) {
			var path = this.props.isSwag ? 'store' : 'races';
			this.props.push(`/${path}/${this.props.challengeUrl}/${this.props.initialStep}`);
		//}
	}

	get _checkout() {
		return (
			<a onClick={this._onClick}>
				<span className="shopping-cart-menu-link">
					<Icon className="shopping-cart-menu-link-icon" type="shopping-cart" />
					<span className="shopping-cart-count">{this.props.count}</span>				
				</span>
			</a>
		);
	}

	get _startOver() {
		return (
			<a className="empty-shopping-cart-menu-link" onClick={this.props.onClearBundle}>
				<span className="empty-shopping-cart-menu-link-text">
					<Icon type="close" />
					Empty Cart
				</span>
			</a>
		);
	}

	render() {
		return this.props.type === 'checkout' ? this._checkout : this._startOver;
	}
}
